<template>
  <div class="dashboard-layout">
    <Sidebar />
    <div class="dashboard-content">
      <!-- <header class="dashboard-header">
        <div class="header-title">
          <slot name="header-title">Dashboard</slot>
        </div>
        <div class="header-actions">
          <div class="notification-bell">
            <v-icon>mdi-bell-outline</v-icon>
          </div>
        </div>
      </header> -->
      <main class="dashboard-main">
        <slot></slot>
      </main>
    </div>
  </div>
</template>

<script>
import Sidebar from './Sidebar.vue'

export default {
  name: 'DashboardLayout',
  components: {
    Sidebar
  }
}
</script>

<style scoped>
.dashboard-layout {
  display: flex;
  min-height: 100vh;
  height: 100%;
  background-color: #f7f8fc;
}

.dashboard-content {
  margin-left: 220px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.dashboard-header {
  height: 64px;
  background-color: white;
  border-bottom: 1px solid #eaedf3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
}

.header-title {
  font-size: 20px;
  font-weight: bold;
  color: #2e3b4e;
}

.header-actions {
  display: flex;
  align-items: center;
}

.notification-bell {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #f5f6fa;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.dashboard-main {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
}
</style> 